import { styled } from '@mui/material/styles';
import { Box, Typography, Avatar, Divider } from '@mui/material';

export const ProgressContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start', // Align items to the top for better connector placement
  marginBottom: theme.spacing(4),
  paddingBottom: theme.spacing(2.5),
  borderBottom: `1px solid ${theme.palette.divider}`,
  position: 'relative', // Needed for absolute positioning of dividers if used that way
}));

export const StepWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'relative',
  flex: 1,
  textAlign: 'center',
});

export const StepConnector = styled(Divider)(({ theme, completed }) => ({
  position: 'absolute',
  top: '20px',
  left: 0,
  right: 0,
  zIndex: 1,
  borderColor: completed ? theme.palette.secondary.main : theme.palette.divider,
  borderTopWidth: '3px',
  margin: '0 22px',
}));


export const StepNumberAvatar = styled(Avatar, {
  shouldForwardProp: (prop) => prop !== 'active' && prop !== 'completed',
})(({ theme, active, completed }) => ({
  width: 40,
  height: 40,
  backgroundColor: completed ? theme.palette.secondary.main : (active ? theme.palette.secondary.main : theme.palette.grey[300]),
  color: completed ? theme.palette.common.white : (active ? theme.palette.common.white : theme.palette.text.secondary),
  fontWeight: 'bold',
  margin: '0 18px',
  zIndex: 2, // Ensure avatar is above the connector line
  boxShadow: active ? `0 0 0 5px ${theme.palette.secondary.main}33` : 'none', // 20% opacity
  transition: 'all 0.3s ease',
}));

export const StepLabel = styled(Typography, {
    shouldForwardProp: (prop) => prop !== 'active' && prop !== 'completed',
})(({ theme, active, completed }) => ({
  marginTop: theme.spacing(1),
  fontSize: '14px',
  color: completed ? theme.palette.secondary.main : (active ? theme.palette.secondary.main : theme.palette.text.secondary),
  fontWeight: active ? 'bold' : 'normal',
}));